import { ref, set } from 'firebase/database'
import { database } from '../firebaseConfig'

const db = database
export async function writeMessageToDB(data) {
  const time = new Date().getTime()
  try {
    await set(ref(db, 'messages/' + time), {
      company_name: data.company_name,
      name: data.name,
      job_title: data.job_title,
      email: data.email,
      message: data.message,
    })
  } catch (error) {
    console.error(`寄送失敗：${error}`)
  }
}
